import { useAuthService } from '@/services/auth';
import LocalSignInPage from './LocalSignInPage';
import CognitoSignInPage from './CognitoSignInPage';
import CnSignInPage from './CnSignInPage';

const SignInPage = () => {
  const { authType } = useAuthService();

  switch (authType) {
    case 'cognito': {
      return <CognitoSignInPage />;
    }
    case 'local': {
      return <LocalSignInPage />;
    }
    case 'cn': {
      return <CnSignInPage />;
    }
  }
};

export default SignInPage;
